import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/workspace/$workspaceId/')({
  beforeLoad: async (ctx) => {
    throw redirect({
      to: '/workspace/$workspaceId/listening',
      params: {
        workspaceId: ctx.params.workspaceId,
      },
    });
  },
});
